var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_3404_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3404_10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3404_10",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3404_10",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7ElEQVR4nO3cQU7DMBCFYZ8JFnAR270J7OiSE2H3UKDeoMiVEFmEEHvczjj5Pym7KqXvJU1x03EOAAAAAAAAALqK+dUdTk/i/ZR9lH2hQkxHF/PFxXR24ePZtfKnRxfy13VfIb0372ef4eeLqIRp+D8bJdSG31jCXPiU0Bp+ZQlL4VPCH8pFcjH8SQlLF+brBTed1+2LC/OvkB5cTJ+rS5g7E9Yc+WuL3KUgKIHwFUsg/M6q3sfL4yoey9vOLc6E0cLv9qLy/GauBEvhj1RAlxKshT9aAaISLIY/YgFNJVgNf9QCfM0/WR1WUW9qtAJ8bfjWSxipAN8avuUSRinAS8O3XIJ1vlf4lFCPpQhFvmFJucdSNpxsSZkShHosKVOCAF9JGhDzS9OR33ImhPx2l9e0nRJS3drOUgmEX1tC48LaXAmEX1uCcFVzWgLhV+LmXAAAAAAAAADAwJgdoYjZEYqYHaGI2RHaX0n+91PWdBQ/z2bnBR0EJTA7wti8IOlNX5sX7zAviPANzAviyLdwcy5vOzudF7TqDxRsrXYzL8hqAbuZF2S5gF38SM96AQXzgpQLKJgXpFxAwbwg5QIK5gUpF7C5eUGjCmtLIHzFEghfsQTCVyyB8BVLIHw95ZMOn3YAAAAAAAAAwPX3DSD6/FHsgoTwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceBlue);
export default __webpack_public_path__ + "static/media/attendance-blue.aa8568f65d8a6608792f6bed980dcf1c.svg";
export { ForwardRef as ReactComponent };